import { put, call, takeEvery, takeLatest, all, delay } from 'redux-saga/effects';

import Actions from '../Actions/Creators';
import Types from '../Actions/Types';
import Phi from '../Phi/Phi';

import moment from "moment";
import XMLParser from "react-xml-parser";

import Constants from '../Phi/Constants';

// import {getMetadata} from 'page-metadata-parser'
// import {JSDOM} from "jsdom";

function* getOrganization(action) {
    // yield put(Actions.setLoader(`Fetching school details.`));
    try {
        const organization = yield call(Phi.Organization.getOrganization, Phi.Organization, action.orgId);

        // if (
        //     organization &&
        //     organization.inOrganizationCustomJson &&
        //     organization.inOrganizationCustomJson.schoolContentID
        // ) {
        //     yield put(
        //         Actions.fetchAllDocs(
        //             organization.inOrganizationCustomJson.schoolContentID,
        //             Constants.documentGroups.organizationDocuments
        //         )
        //     );
        // }

        let country, state, city, goLiveFlag, guidedTourFlag, SOPResources;

        if (organization.inOrganizationState && organization.inOrganizationDistrict) {
            const countryResponse = yield call(Phi.Organization.getMetaData, Phi.Organization, { metaType: "country" });
            country = (countryResponse && countryResponse.length && countryResponse[0]) || {};

            const stateResponse = yield call(Phi.Organization.getMetaData, Phi.Organization, {
                metaType: "state",
                config: { countryId: country.id || Constants.defaultRegionCodes.INDIA_COUNTRY_CODE },
            });
            state =
                (stateResponse &&
                    stateResponse.length &&
                    stateResponse.filter((state) => state.id === organization.inOrganizationState)[0]) ||
                {};

            const cityResponse = yield call(Phi.Organization.getMetaData, Phi.Organization, {
                metaType: "city",
                config: { stateId: state.id },
            });
            city =
                (cityResponse &&
                    cityResponse.length &&
                    cityResponse.filter((city) => city.id === organization.inOrganizationDistrict)[0]) ||
                {};
        }

        if (organization && organization.inOrganizationCustomJson) {
            goLiveFlag = Boolean(organization.inOrganizationCustomJson.isOrganizationMadeLive);
            guidedTourFlag = Boolean(organization.inOrganizationCustomJson.isOrganizationTourCompleted);
            SOPResources = organization.inOrganizationCustomJson.SOPResources ? organization.inOrganizationCustomJson.SOPResources.url : null
        }

        yield put(
            Actions.storeOrganization({
                ...organization,
                countryName: (country && country.country_name) || "",
                stateName: (state && state.state_desc) || "",
                cityName: (city && city.city_name) || "",
                goLiveFlag,
                guidedTourFlag,
                SOPResources
            })
        );
    } catch (error) {
        console.error(error);
    }
    // yield put(Actions.unsetLoader());
}

function* getCovidGlobalDashboard(action) {
    let { stateName, cityName } = action;
    stateName = stateName ? stateName : ''
    cityName = cityName ? cityName : ''
    
    let possibleState, possibleDistrict, possibleResults

    stateName = Constants.getCovidGlobalDashboardReplaceText(stateName.toLowerCase());
    cityName = Constants.getCovidGlobalDashboardReplaceText(cityName.toLowerCase());

    let stateCode = Constants.stateCodeMap[stateName.toLowerCase()] || ''

    const globalDashboard = yield call(Phi.Organization.getCovidGlobalDashboardInd, Phi.Organization);
    yield put(Actions.storeCovidData(globalDashboard));

    possibleState = globalDashboard[stateCode.toUpperCase()] || {}
   if(cityName.length !== 0) {
        possibleDistrict = possibleState.districts || {}
        possibleDistrict = Constants.convertObjectToArray(possibleDistrict);
        possibleDistrict = possibleDistrict.filter((element) => !!Object.keys(element)[0].match(cityName));
   }

    if ( possibleDistrict && possibleDistrict.length && possibleDistrict[0] && possibleDistrict[0][Object.keys(possibleDistrict[0])] && possibleDistrict[0][Object.keys(possibleDistrict[0])].total) {
        possibleDistrict = possibleDistrict[0][Object.keys(possibleDistrict[0])].total
        yield put(Actions.responseCovidGlobalDashboard({
            deceased: possibleDistrict.deceased || 0,
            recovered: possibleDistrict.recovered || 0,
            confirmed: possibleDistrict.confirmed || 0,
            active: parseInt(possibleDistrict.confirmed || 0) - parseInt(possibleDistrict.recovered || 0)
        }));
    }else if ( possibleState && possibleState.total ) {
        possibleState = possibleState.total
        yield put(Actions.responseCovidGlobalDashboard({
            deceased: possibleState.deceased || 0,
            recovered: possibleState.recovered || 0,
            confirmed: possibleState.confirmed || 0,
            active: parseInt(possibleState.confirmed || 0) - parseInt(possibleState.recovered || 0)
        }));
    }else if ( globalDashboard && globalDashboard.TT ) {
        let total = globalDashboard.TT.total
        yield put(Actions.responseCovidGlobalDashboard({
            deceased: total.deceased || 0,
            recovered: total.recovered || 0,
            confirmed: total.confirmed || 0,
            active: (total.confirmed || 0) - (total.recovered || 0)
        }));
    }
}


function* getCovidDeclarationOverallSymptomsV2(action) {
    const overallSymptoms = yield call(Phi.Organization.getCovidDeclarationOverallSymptomsV2, Phi.Organization, {
        organizationId: action.organizationId,
        startDate: action.startDate,
        endDate: action.endDate,
        userRole: action.userRole,
        metaFilter: JSON.stringify(action.metaFilters),
    });

    if (overallSymptoms && overallSymptoms.length) {
        yield put(Actions.responseCovidDeclarationOverallSymptomsV2(JSON.parse(overallSymptoms[0].stats)));
    }
}

function* getCovidGoogleRSSFeed(action) {
    const response = yield call(Phi.Organization.getCovidGoogleRSSFeed, Phi.Organization, {limit: action.limit, start: action.start});

    // let news = yield googleNewsAPI.getNews(googleNewsAPI.TOP_NEWS, null, "en-GB");

    if (response && !response.error) {
    // if (response && response.items) {
        // yield put(
        //     yield put(Actions.responseCovidGoogleRSSFeed(response.items))
        // );
        let parsed = []
        let finalParsed = []
        try {   
            parsed = new XMLParser().parseFromString(response);
            parsed = parsed && parsed.children && parsed.children.length && parsed.children[0].children || []

            parsed.forEach(element => {

                let subElement = {image: null}

                element.children.forEach(e => {
                    subElement = {...subElement, [e.name]: e.value} 
                })
                if (element.name === 'item') {
                    finalParsed.push(subElement)
                }
            })

            finalParsed.sort((a, b) => moment(b.pubDate) - moment(a.pubDate))
        }catch (e) {

        }
        

        // let called = yield all(finalParsed.map(e => call(Phi.Reporting.getOpenAPI, Phi.Reporting, e.link)))

        // const finalParsed2 = finalParsed.map((e, i) => {
            
        //     const doc = domino.createWindow(called[i].data).document;
        //     const metadata = getMetadata(doc, e.link);

        //     return {...e, image: metadata.image}
        // })

        // let x = yield all()

        yield put(Actions.responseCovidGoogleRSSFeed(finalParsed))

        let subFinalParsed = []
        let index = 0

        // for(let i = 0; i<finalParsed.length; i++) {

        //     subFinalParsed.push(finalParsed[i])

        //     if (subFinalParsed.length === 5) {
        //         yield put(Actions.getCovidGoogleRSSFeedImages(subFinalParsed, index))
        //         yield delay(2000)
        //         subFinalParsed = []
        //         index += 5
        //     }
        // }
        // yield put(Actions.getCovidGoogleRSSFeedImages(finalParsed))
    } else {
        yield put(Actions.responseCovidGoogleRSSFeed([]))
    }
}

function* getCovidGoogleRSSFeedImages(action) {

    if(action.rssFeed && action.rssFeed.length) {
        const calls = yield all(action.rssFeed.map((e, i) => call(Phi.Organization.getOpenAPI, Phi.Organization, {link: e.link, index: i})))


        let images = {}
    
        if (calls && calls.length) {
            calls.forEach((e, i) => {
                // const doc = JSDOM.fragment(e.data)
                // const metadata = getMetadata(doc, action.rssFeed[i].link)
    
                images = { ...images, ...e }
            })
        }
    
        yield put(
            Actions.responseCovidGoogleRSSFeedImage(images)
        )
    }
}

// function* getCovidGoogleRSSFeedImages(action) {
//     let calls = yield all(action.rssFeed.map((e, i) => call(Phi.Organization.getOpenAPI, Phi.Organization, e.link)))

//     let doc, metadata

//     // yield all(action.rssFeed.map((e, i) => {
//     //     if (calls[i] && calls[i].data) {
//     //         const dom = JSDOM.fragment(calls[i].data)
//     //         doc = dom
//     //         metadata = getMetadata(doc, e.link)
    
//     //         return(
//     //             put(
//     //                 Actions.responseCovidGoogleRSSFeedSingleImage({
//     //                     index: action.index + i, 
//     //                     image: metadata.image,
//     //                 })
//     //             )
//     //         )
//     //     }
        
//     // }))

//     let imageObj = {}

//     action.rssFeed.map((e, i) => {
//         if (calls[i] && calls[i].data) {
//             const dom = JSDOM.fragment(calls[i].data)
//             doc = dom
//             metadata = getMetadata(doc, e.link)
    
//             imageObj = { ...imageObj, [action.index + i]: metadata.image }
//         }
//     })

//     yield put(
//         Actions.responseCovidGoogleRSSFeedImage(imageObj)
//     )
// }


// function* getCovidGoogleRSSFeedSingleImage(action) {
//     let called = yield call(Phi.Organization.getOpenAPI, Phi.Organization, action.link)

//     if (called && called.data) {
//         const doc = domino.createWindow(called.data).document
//         const metadata = getMetadata(doc, action.link)

//         yield put(
//             Actions.responseCovidGoogleRSSFeedSingleImage({
//                 index: action.index,
//                 image: metadata.image,
//             })
//         )
//     } else {
//         yield put(
//             Actions.responseCovidGoogleRSSFeedSingleImage({
//                 index: action.index,
//                 image: null,
//             })
//         )
//     }
// }

// Saga Watcher
export function* watchOrganizationActions() {
    yield* [
        takeEvery(Types.GET_ORGANIZATION, getOrganization),
        takeEvery(Types.GET_GLOBAL_COVID_DASHBOARD, getCovidGlobalDashboard),

        takeEvery(Types.GET_COVID_DECLARATION_OVERALL_SYMPTOMS_V2, getCovidDeclarationOverallSymptomsV2),

        takeEvery(Types.GET_COVID_GOOGLE_RSS_FEED, getCovidGoogleRSSFeed),
        // takeEvery(Types.GET_COVID_GOOGLE_RSS_FEED_SINGLE_IMAGE, getCovidGoogleRSSFeedSingleImage),
        takeEvery(Types.GET_COVID_GOOGLE_RSS_FEED_IMAGES, getCovidGoogleRSSFeedImages)
    ]
}